import axios from 'axios'

/**
 * 后端基础地址，与 request.js 保持一致。
 * 生产环境走域名 lyqanddyl.com（nginx 分流）。
 */
const BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://lyqanddyl.com'
  : ''

/**
 * 登录。
 * 由于登录接口的响应格式（旧格式 success/token/user 在外层）与业务接口不同，
 * 此处不使用拦截器，直接返回完整 response.data 供调用方自行解析。
 * @param {string} username 用户名。
 * @param {string} password 密码。
 * @returns {Promise<{success?: boolean, code?: number, message?: string, token?: string, user?: Object, data?: {token?: string, user?: Object}}>}
 */
export function login(username, password) {
  return axios({
    baseURL: BASE_URL,
    url: '/api/login',
    method: 'POST',
    data: { username, password },
  }).then((response) => response.data)
}

/**
 * 注册。
 * @param {string} username 用户名。
 * @param {string} password 密码。
 * @returns {Promise<{success?: boolean, message?: string}>}
 */
export function register(username, password) {
  return axios({
    baseURL: BASE_URL,
    url: '/api/register',
    method: 'POST',
    data: { username, password },
  }).then((response) => response.data)
}
